// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c4991a9","239":"9622c8a7","453":"d69ef50c","455":"98a49440"}[chunkId] + ".chunk.js";
};